<template>
  <div class="mgmt-table">
    <div  class="mgmt-line mgmt-table-header"
          :style="[ getTableSetup(name, mode),{'height': (name === 'ContactQuota2025' ? '4.8rem !important' : '')}]">
      <div v-for="(header, index) in headers(name, mode)" :key="index">
        <div>{{ header.header1 || '&nbsp;' }}</div>
        <div>{{ header.header2 || '&nbsp;' }}</div>
        <div>{{ header.header3 || '&nbsp;' }}</div>
      </div>
    </div>

    <div  class="mgmt-line" 
          :style="[getTableSetup(name, mode)]"
          v-for="(item, i) in items" :key="i"> 
      
      <!-- Header (Quartal)-->
      <div :class="[ 'mgmt-name', { 'mgmt-name-circle': getActiveQuarter(i) } ]">
        {{ getQuarterHeaderText(item) }}
      </div>

      <management-cell  :render="item.val1Render" 
                        :val="item.val1" 
                        :thresholds="thresholds" />
      <management-cell  :render="item.val2Render" 
                        :val="item.val2" 
                        :thresholds="thresholds" />
      <management-cell  :render="item.val3Render" 
                        :val="item.val3" 
                        :thresholds="thresholds" />
      <management-cell  v-if="item.val4 || item.val4Render || name === 'ContactQuota2025'" 
                        :render="item.val4Render" 
                        :val="item.val4" 
                        :thresholds="thresholds" />
      <management-cell  v-if="item.val5 || item.val5Render" 
                        :render="item.val5Render" 
                        :val="item.val5" 
                        :thresholds="thresholds" />
      <management-cell  v-if="item.val6 || item.val6Render" 
                        :render="item.val6Render" 
                        :val="item.val6" 
                        :thresholds="thresholds" />
      <management-cell  v-if="item.val7 || item.val7Render" 
                        :render="item.val7Render" 
                        :val="item.val7" 
                        :thresholds="thresholds" />
    </div>
  </div>
</template>

<script>
import DateMixin from '@/mixins/DateMixin';
import EventBus from "@/services/EventBus";
import ManagementCell from '@/components/CX/DashboardCards/ManagementCell.vue';
import moment from "moment";

export default {
  mixins: [ DateMixin ],

  components: {
    ManagementCell
  },

  props: {
    data:       { type: Array,  default: [] },
    customData: { type: Object, default: {} },
    mode:       { type: String, default: 'quarterly' },
    name:       { type: String, default: undefined },
    selection:  { type: String, default: undefined },
    thresholds: { type: Array,  required: true },
    year:       { type: Number, default: undefined }
  },

  methods: {
    getQuarterHeaderText(item) {
      if (item && item.name)
        return item.name;
      return '';
    },

    getActiveQuarter(index) {
      if (this.mode !== 'quarterly') 
        return false;
      return this.isActiveQuarter(index, this.year);
    },

    getMarginThreshold() {
      EventBus.$emit('nps-margin-header', this.year >= 2023 ? '55' : '50');
      return this.year >= 2023 ? '55' : '50';
    },

    getIconValue(item) {
      if (item) {
        return item.Margin === 0 ? false : true;
      }
      return undefined;
    },

    getQuarter(name, year, quarter) {
      let item = _.find(this.data, { 'Year': year, 'Quarter': quarter });
      let margin = item?.Margin || item?.Margin === 0 ? this.$n(item.Margin * 100, { minimumFractionDigits: 1, maximumFractionDigits: 1}) : undefined;
      let qTitle = `Q${quarter}`;

      switch (name) {
        case 'LeadManagement':
          return { 
            name: qTitle, 
            val1: item?.NumberOfCalls, 
            val2: item?.ContactedLeads, 
            val3: item?.FullfillmentRate, 
            val3Render: 'bar',
            val4Render: 'numeric',
            val4: margin };

        case 'ClosedRedFlags': 
          return { 
            name: qTitle, 
            val1: item?.TotalRedFlags, 
            val2: item?.ClosedRedFlags, 
            val3: item?.CloseTime,
            val4: this.getIconValue(item),
            val4Render: 'icon' };

        case 'ContactQuota': 
          return { 
            name: qTitle, 
            val1: item?.HandOver, 
            val2: item?.UsableContacts, 
            val3: item?.UnusableContacts, 
            val4: item?.FullfillmentRate,
            val4Render: 'bar',
            val5: this.getIconValue(item),
            val5Render: 'icon' };
        
        case 'ContactQuota2025': 
          let details = this.customData.details.filter(e => e.Year === year && e.Quarter === quarter)
          return { 
            name: qTitle, 
            val1: item?.TotalDataSets, 
            val2: item?.FulfilledEmail, 
            val3: item?.FulfillmentRateEmail, 
            val3Render: 'bar',
            val4: item?.FulfilledPhone,
            val5: item?.FulfillmentRatePhone,
            val5Render: 'bar',
            val6: item?.MarginFulfilled,
            val6Render: 'icon',
            val7: { "data": details, "year": year, "quarter": quarter },
            val7Render: "search-contactQuota",
          };
        
        case 'NPS':
          return { 
            name: qTitle, 
            val1: item && !item?.FullfilledContactQuota ? '' : item?.FullfilledContactQuota,
            val1Render: 'icon',
            val2: item && item.FullfilledNPS === undefined ? '' : this.getIconValue(item),
            val2Render: 'icon',
            val3: item && item.FullfilledContactQuota === undefined && item.FullfilledNPS === undefined ? true : this.getIconValue(item),
            val3Render: 'icon' };
      }
    },

    getMonth(name, year, month) {
      let item = _.find(this.data, { 'Year': year, 'Month': month });
      let margin = item?.Margin ? this.$n(item.Margin * 100, { minimumFractionDigits: 1, maximumFractionDigits: 1}) : undefined;
      let mTitle = moment({ month: month - 1}).format("MMM");

      switch (name) {
        case 'LeadManagement': 
          return { 
            name: mTitle, 
            val1: item?.NumberOfCalls, 
            val2: item?.ContactedLeads, 
            val3: item?.FullfillmentRate, 
            val3Render: 'bar',
            val4Render: 'numeric',
            val4: margin };

        case 'ClosedRedFlags': 
          return { 
            name: mTitle, 
            val1: item?.TotalRedFlags, 
            val2: item?.ClosedRedFlags, 
            val3: item?.CloseTime };

        case 'ContactQuota': 
          return { 
            name: mTitle, 
            val1: item?.HandOver, 
            val2: item?.UsableContacts, 
            val3: item?.UnusableContacts, 
            val4: item?.FullfillmentRate,
            val4Render: 'bar',
            val5: margin };

        case 'NPS': 
          throw new Error(`getMonth-Not Implemented: [${name}]`);

        default: 
          throw new Error(`getMonth-Type missing: [${name}]`);
      }
    },

    getCustomInControl(year, quarter, offset) {
      let month = (quarter - 1) * 3 + offset;
      let item = _.find(this.customData.monthly, { 'Year': year, 'Month': month });
      let mTitle = moment({ month: month - 1}).format("MMM");

      let result = { 
        name: item ? mTitle : null,
        val1: item?.ProvisionedCount,
        val2: item?.ActiveCount,
        val3: item?.SilentCount,
        val4: item?.FullfillmentRate,
        val4Render: 'bar',
        val5: item?.Fullfilled,
        val5Render: 'icon' };

      return result;
    },

    headers(name, mode) {
      switch (name) {
        case 'LeadManagement2025': 
          return [ {},
            { header1: this.$t('Webportal.Dashboard.Count'), header2: this.$t('Webportal.CX.Leads'), header3: '(n)' },
            { header1: this.$t('Webportal.CX.Thereof'), header2: this.$t('Webportal.CX.Fulfilled'), header3: '(n)' },
            { header2: this.$t('Webportal.CX.Fulfilled'), header3: '(%)' },
            { header2: this.$t('Webportal.CX.Details'), header3: '' } ];
        case 'LeadManagement': 
          return [ {},
            { header1: this.$t('Webportal.Dashboard.Count'), header2: this.$t('Webportal.CX.Calls'), header3: '(n)' },
            { header1: this.$t('Webportal.CX.Leads'), header2: this.$t('Webportal.CX.Contacted'), header3: '(n)' },
            { header2: this.$t('Webportal.CX.Fulfilled'), header3: '(%)' },
            { header2: this.$t('Webportal.CX.Margin'), header3: '' } ];

        case 'ClosedRedFlags': 
          let data = [ {},
            { header1: this.$t('Webportal.Dashboard.Count'), header2: this.$t('Webportal.CX.RedFlags'), header3: '(n)' },
            { header1: this.$t('Webportal.CX.Closed'), header2: this.$t('Webportal.CX.RedFlags'), header3: '(n)' },
            { header1: this.$t('Webportal.CX.Closing') + '-', header2: this.$t('Webportal.CX.time') , header3: '(<72h)' } ];

          if (this.mode == 'quarterly')
            data.push({ header2: this.$t('Webportal.CX.Margin'), header3: '' });
          return data;

        case 'ContactQuota': 
          return [ {},
            { header1: 'Hand', header2: 'Over', header3: '(n)' },
            { header1: this.$t('Webportal.CX.Usable'), header2: this.$t('Webportal.CX.Contacts'), header3: '(n)' },
            { header1: this.$t('Webportal.CX.NotUsable'), header2: this.$t('Webportal.CX.Contacts'), header3: '(n)' },
            { header1: '', header2: this.$t('Webportal.CX.Fulfilled'), header3: `(${this.getMarginThreshold()}%)` },
            { header2: this.$t('Webportal.CX.Margin'), header3: '' } ];

        case 'ContactQuota2025': 
          return [ {},
            { header1: this.$t('Webportal.Dashboard.Count'), header2: this.$t('Webportal.CX.ContactQuota2025Header1_2'), header3: '(n)' },
            { header1: this.$t('Webportal.CX.Thereof'), header2: this.$t('Webportal.CX.ContactQuota2025Header2_2'), header3: '(n)' },
            { header1: this.$t('Webportal.CX.ContactQuota2025Header3_2'), header2: this.$t('Webportal.CX.ContactQuota2025Header3_3') },
            { header1: this.$t('Webportal.CX.Thereof'), header2: this.$t('Webportal.CX.ContactQuota2025Header4_2'), header3: `(n)` },
            { header1: this.$t('Webportal.CX.ContactQuota2025Header5_2'), header2: this.$t('Webportal.CX.ContactQuota2025Header5_3') },
            { header1: '', header2: this.$t('Webportal.CX.Margin') },
            {} ];

        case 'NPS': 
          return [ {},
            { header1: this.$t('Webportal.CX.Fulfillment') + ' ' + this.$t('Webportal.CX.Of'), header2: this.$t('Webportal.CX.ContactQuota'), header3: `(${this.getMarginThreshold()}%)` },
            { header1: this.$t('Webportal.CX.NPSof'), header2: this.$t('Webportal.CX.MinimumShort') + ` ${this.getMarginThreshold()}` },
            { header2: this.$t('Webportal.CX.Margin'), header3: '' } ];

        case 'InControl':
          return [ {},
            { header1: 'Pro-', header2: 'visioned' },
            { header1: 'Active', header2: 'Legislated' },
            { header1: 'Silent', header2: 'Legislated' },
            { header1:this.$t('Webportal.CX.Fulfilled'), header2: '(75%)' },
            { header1: this.$t('Webportal.CX.Margin') } ];

        default: 
          throw new Error(`Headers-Type missing: [${name}]`);
      }
    },

    getTableSetup(name, mode) {
      switch (name) {
        case 'LeadManagement': 
          return { 'grid-template-columns': '2fr 3fr 3fr 5fr 2fr' };

        case 'LeadManagement2025': 
          return { 'grid-template-columns': '2fr 3fr 3fr 5fr 2fr' };

        case 'ClosedRedFlags': 
          if (this.mode == 'quarterly')
            return { 'grid-template-columns': '1fr 3fr 3fr 4fr 2fr' };
          return { 'grid-template-columns': '2fr 3fr 3fr 3fr' };

        case 'ContactQuota': 
          return { 'grid-template-columns': '2fr 2fr 4fr 4fr 3fr 2fr' };
          
        case 'ContactQuota2025': 
          return { 'grid-template-columns': '1fr 2fr 2fr 2fr 2fr 2fr 1fr 1fr' };

        case 'NPS': 
          return { 'grid-template-columns': '2fr 3fr 3fr 3fr' };

        case 'InControl': 
          return { 'grid-template-columns': '2fr 2fr 4fr 4fr 3fr 2fr' };

        default: 
          throw new Error(`Setup-Type missing: [${name}]`);
      }
    }
  },

  computed: {
    items() {
      if (this.name === 'InControl') {
        if (!this.selection)
          return undefined;
        
        // get 2nd char as quarter as number between 1..4 and convert to number
        let quarter = parseInt(this.selection.substring(1, 2));

        // get last 4 chars as year as number between
        let year = parseInt(this.selection.substring(3, 7));

        return [ 
          this.getCustomInControl(year, quarter, 1),
          this.getCustomInControl(year, quarter, 2),
          this.getCustomInControl(year, quarter, 3)
        ];
      }

      if(this.name === 'LeadManagement2025') {
        let year = this.data[0].Year;
        let quarter = this.data[0].Quarter;
        let initialLeadHandling_details = null;
        if(this.customData.initialLeadHandling) {
          initialLeadHandling_details = {"data": this.customData.initialLeadHandling.filter(e => e.Year === year && e.Quarter === quarter), "year": year, "quarter": quarter};
        }
        let leadClosing_details = null;
        if(this.customData.leadClosing) {
          leadClosing_details = {"data": this.customData.leadClosing.filter(e => e.Year === year && e.Quarter === quarter), "year": year, "quarter": quarter};
        }
        let phaseDuration_details = null;
        if(this.customData.phaseDuration) {
          phaseDuration_details = {"data": this.customData.phaseDuration.filter(e => e.Year === year && e.Quarter === quarter), "year": year, "quarter": quarter};
        }

        let res = [
          { 
            name: "E1",
            val1: this.data[0].E1TotalLeads ? this.data[0].E1TotalLeads : null,
            val2: this.data[0].E1FulfilledLeads ? this.data[0].E1FulfilledLeads : null,
            val3: this.data[0].E1FulfillmentRate ? this.data[0].E1FulfillmentRate : null,
            val3Render: "bar",
            val4: initialLeadHandling_details,
            val4Render: "search-initialLeadHandling",
          },
          { 
            name: "E2",
            val1: this.data[0]?.E2TotalLeads,
            val2: this.data[0]?.E2FulfilledLeads,
            val3: this.data[0]?.E2FulfillmentRate,
            val3Render: "bar",
            val4: phaseDuration_details,
            val4Render: "search-phaseDuration",
          },
          { 
            name: "E3",
            val1: this.data[0]?.E3TotalLeads,
            val2: this.data[0]?.E3FulfilledLeads,
            val3: this.data[0]?.E3FulfillmentRate,
            val3Render: "bar",
            val4: leadClosing_details,
            val4Render: "search-leadClosing",
          },
        ];
        return res;
      }

      if (this.mode == 'quarterly') {
        return [ 
          this.getQuarter(this.name, this.year, 1), 
          this.getQuarter(this.name, this.year, 2),
          this.getQuarter(this.name, this.year, 3), 
          this.getQuarter(this.name, this.year, 4) ];
      } 

      let months = [];
      for (let i = 1; i <= 12; i++) {
        months.push(this.getMonth(this.name, this.year, i));
      }
      return months;
    }
  }
}

</script>
